import { IconSvg, IconSvgProps } from "./icon"

export default function WarningTriangleFill(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.659 .387a2.571 2.571 0 0 1 3.629 1.022l.003 .007l9.429 18.855A2.571 2.571 0 0 1 21.429 24H2.571a2.571 2.571 0 0 1-2.29-3.727v-.002L9.71 1.416l.003-.007a2.571 2.571 0 0 1 .948-1.022ZM12 7.071a1.286 1.286 0 0 1 1.286 1.286v5.571a1.286 1.286 0 0 1-2.571 0v-5.571a1.286 1.286 0 0 1 1.286-1.286Zm1.714 11.571a1.714 1.714 0 1 1-3.429 0a1.714 1.714 0 0 1 3.429 0Z"
        clipRule="evenodd"
      />
    </IconSvg>
  )
}
